import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002293a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick", "disabled"]

import PropCaseHelper from '@/services/helpers/PropCaseHelper';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
interface LinkTabProps {
    /** When paramKey isn't defined, these are the route names
     * Keys of the tabs, display if tabDisplayMap not defined
    */
    tabs: string[],
    tabDisplayMap?: Record<string, string>,
    /** Keys of the tabs that are not clickable */
    disabled?: string[],
    paramKey?: string,
}
interface ParamTabProps extends LinkTabProps {
    /** Key of the route params to fetch current tab */
    paramKey: string,
}
const routeNameNullErrorText = 'name is not defined for current tab';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabbedRouterView',
  props: {
    tabs: {},
    tabDisplayMap: {},
    disabled: {},
    paramKey: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();
const emits = __emit;
const props = __props;
const key = ref(0);
const cur = computed(()=>(
    isParamTabProps(props)?
        (router.currentRoute.value.params[props.paramKey] as string)??props.tabs[0]:
        router.currentRoute.value.name?.toString()??(()=>{throw new ReferenceError(routeNameNullErrorText)})()
).toUpperCase());
function isParamTabProps(x: LinkTabProps|ParamTabProps): x is ParamTabProps {
    return !!(x as ParamTabProps).paramKey;
}
function getParamLocation(x: ParamTabProps, tab: string) {
    const paramKey = x.paramKey
    return {
        name: router.currentRoute.value.name??(()=>{throw new ReferenceError(routeNameNullErrorText)})(),
        params: {
            [paramKey]: tab.toLowerCase(),
        }
    };
}
function changeTab(tab: string) {
    const newLocation = isParamTabProps(props) ?
        getParamLocation(props, tab) :
        {name: tab};
    if (cur.value === tab.toUpperCase()) {
        key.value = key.value + 1;
        if (key.value > 10000) key.value = 0;
    } else router.push(newLocation);
    emits('change', tab);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(['tab', {'selected':cur.value.startsWith(tab.toUpperCase())}]),
          onClick: ($event: any) => (changeTab(tab)),
          disabled: _ctx.disabled?.includes(tab)
        }, [
          _renderSlot(_ctx.$slots, "default", { value: tab }, () => [
            _createTextVNode(_toDisplayString(_ctx.tabDisplayMap?.[tab] ?? _unref(PropCaseHelper).toSentenceName(tab)), 1)
          ])
        ], 10, _hoisted_3))
      }), 256))
    ]),
    (_openBlock(), _createBlock(_component_RouterView, { key: key.value }))
  ]))
}
}

})